import IconStand from './IconStand';
export default IconStand;